import Swal from 'sweetalert2'
import {
  downloadArquivo,
  IconPaths,
  showAlertLoading,
  showError,
} from '../../../../../../../_metronic/helpers'
import { Button } from '../../../../../../components'
import { ArquivoDto } from '../../../../atendimento/core/_models'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { RelatorioNpsListSearchComponent } from './RelatorioNpsSearchComponent'
import { getCsvNps, getPdfNps } from '../../core/_requests'

export const RelatorioNpsListHeader = () => {
  const { state } = useQueryRequest()

  // Mesma busca do resumo + o texto dos filtros, que o backend imprime no arquivo.
  const exportar = async (baixar: (query: string) => Promise<ArquivoDto>) => {
    try {
      showAlertLoading()
      const arquivo = await baixar(`search=${state.search}&filters=${state.filtersNPS}`)
      Swal.close()
      downloadArquivo(arquivo)
    } catch (error) {
      showError(error)
    }
  }

  return (
    // Card só com os filtros (sem tabela abaixo): `py-6` fecha o espaçamento embaixo também.
    <div className='card-header border-0 py-6'>
      <RelatorioNpsListSearchComponent
        actions={
          <>
            <Button
              variant='secondary-outline'
              icon={IconPaths.Pdf}
              onClick={() => exportar(getPdfNps)}
            >
              Exportar PDF
            </Button>
            <Button
              variant='secondary-outline'
              icon={IconPaths.Csv}
              onClick={() => exportar(getCsvNps)}
            >
              Exportar CSV
            </Button>
          </>
        }
      />
    </div>
  )
}
